'use strict'

var assign = require('object-assign')

module.exports = u

function u(type, props, value) {
  var node

  if (
    (value === null || value === undefined) &&
    (typeof props !== 'object' || Array.isArray(props))
  ) {
    value = props
    props = {}
  }

  node = assign({type: String(type)}, props)

  if (Array.isArray(value)) {
    node.children = value
  } else if (value !== null && value !== undefined) {
    node.value = String(value)
  }

  return node
}



//////////////////
// WEBPACK FOOTER
// ./~/unist-builder/index.js
// module id = 29
// module chunks = 95715928098905 168707334958949